import React from 'react';
import { getAnnualProjectPrograms } from '../services/annualProjectProgramsService';
import {
  ANNUAL_PROJECT_PROGRAMS_CHANGE_EVENT,
  AnnualProjectProgram,
  readAnnualProjectProgramsCache,
} from '../utils/annualProjectProgramsStorage';

/**
 * 연간 프로젝트 프로그램 목록: LS 캐시를 먼저 보여 주고,
 * 마운트·스코프 변경 시 head(`id/updated_at`) 비교로 DB와 맞춘다.
 */
export function useAnnualProjectProgramsResolved(
  workspaceId: string,
  gradeId: string,
  academicYear: number
): AnnualProjectProgram[] {
  const [list, setList] = React.useState<AnnualProjectProgram[]>(() =>
    workspaceId && gradeId ? readAnnualProjectProgramsCache(workspaceId, gradeId, academicYear) : []
  );

  React.useEffect(() => {
    if (!workspaceId || !gradeId) {
      setList([]);
      return;
    }
    const cached = readAnnualProjectProgramsCache(workspaceId, gradeId, academicYear);
    setList(cached);
    let cancelled = false;
    void getAnnualProjectPrograms(workspaceId, gradeId, academicYear).then((rows) => {
      if (!cancelled) setList(rows);
    });
    return () => {
      cancelled = true;
    };
  }, [academicYear, gradeId, workspaceId]);

  React.useEffect(() => {
    if (!workspaceId || !gradeId) return undefined;
    const onChanged = (event: Event) => {
      const detail = (event as CustomEvent<{ workspaceId?: string; gradeId?: string; academicYear?: number }>).detail;
      if (
        detail?.workspaceId !== workspaceId ||
        detail?.gradeId !== gradeId ||
        detail?.academicYear !== academicYear
      ) {
        return;
      }
      setList(readAnnualProjectProgramsCache(workspaceId, gradeId, academicYear));
    };
    window.addEventListener(ANNUAL_PROJECT_PROGRAMS_CHANGE_EVENT, onChanged as EventListener);
    return () => window.removeEventListener(ANNUAL_PROJECT_PROGRAMS_CHANGE_EVENT, onChanged as EventListener);
  }, [academicYear, gradeId, workspaceId]);

  return list;
}
